import { useMemo } from "react";
import { FeatureCollection, GeoJsonProperties, Point } from "geojson";

export default function useDownload(
  results: FeatureCollection<Point, GeoJsonProperties> | undefined
) {
  const downloadLink = useMemo(() => {
    if(!results) return;
    const excludeKeys = ["pixel_coords"];

    const inferenceHeaders = results.features.length
      ? Object.keys(results.features[0].properties?.inference).filter(
        (key) => !excludeKeys.includes(key)
      )
      : [];

    const formattedInferenceHeaders = inferenceHeaders.map((a) =>
      a
        .replace(/_/g, " ")
        .replace(/-/g, " ")
        .split(" ")
        .map((w) => w[0].toUpperCase() + w.substring(1).toLowerCase())
        .join(" ")
    );

    formattedInferenceHeaders.splice(-2, 2, ...formattedInferenceHeaders.slice(-2).map(str => `${str} (m)`));

    const csvResults = results?.features
      .map(({ geometry, properties }) => [
        new Date(properties?.scene.date).toLocaleDateString("en-US"),
        new Date(properties?.scene.date).toLocaleTimeString("en-US", {
          timeZone: "America/Los_Angeles",
          timeZoneName: "shortOffset",
        }),
        properties?.scene.s3_prefix,
        properties?.inference.pixel_coords.ymin,
        properties?.inference.pixel_coords.xmin,
        properties?.inference.pixel_coords.ymax,
        properties?.inference.pixel_coords.xmax,
        geometry.coordinates[0].toFixed(4),
        geometry.coordinates[1].toFixed(4),
        properties?.is_valid,
        inferenceHeaders.map((key) => properties?.inference[key].toFixed(2))
      ])
      .map((line) => `${line.join(",")}\n`);
    const content = `Scene Date,Scene Time,Scene ID,ymin,xmin,ymax,xmax,Lon,Lat,Valid,${formattedInferenceHeaders}\n${csvResults?.join(
      ""
    )}`;
    const blob = new Blob([content], { type: "text/csv" });
    return window.URL.createObjectURL(blob);
  }, [results]);

  return {
    downloadLink,
  };
}
